var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { styled } from '@a0/quantum-product';
import * as React from 'react';
import { ContentStyler } from '../../ContentRenderer';
import { OverlaySpinner } from '../../Spinner';
var httpMethodBadgeSelector = function (method) {
    return "& .swagger-section .swagger-ui-wrap ul#resources li.resource ul.endpoints li.endpoint ul.operations li.operation.".concat(method, " div.heading h3 span.http_method a");
};
var ManagementApiContent = styled(ContentStyler)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            '& .swagger-section h2.operation-title': __assign({}, theme.typography.h2),
            '& ul > li': {
                listStyleType: 'none',
            },
            '& .form-control:focus': {
                borderColor: theme.palette.primary.light,
                boxShadow: "inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px ".concat(theme.palette.primary.light),
            },
            '& .btn-primary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
                '&:hover': {
                    textDecoration: 'none',
                    backgroundColor: theme.palette.primary.dark,
                },
                '&:active': {
                    backgroundColor: theme.palette.primary.dark,
                },
            },
            '& .action-summary > code, .main-section .action-summary > code': __assign({}, theme.typography.code1),
            '& .swagger-section .sandbox_header a': {
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline',
                },
            }
        },
        _b[httpMethodBadgeSelector('get')] = {
            backgroundColor: theme.palette.primary.light,
        },
        _b[httpMethodBadgeSelector('post')] = {
            backgroundColor: theme.palette.success.main,
        },
        _b[httpMethodBadgeSelector('put')] = {
            backgroundColor: theme.palette.info.main,
        },
        _b[httpMethodBadgeSelector('patch')] = {
            backgroundColor: theme.palette.warning.main,
        },
        _b[httpMethodBadgeSelector('delete')] = {
            backgroundColor: theme.palette.error.main,
        },
        _b);
});
export var StaticPage = function (_a) {
    var _b = _a.content, content = _b === void 0 ? {} : _b;
    var _c = __read(React.useState(true), 2), loading = _c[0], setLoading = _c[1];
    React.useEffect(function () {
        // If the document's content hasn't been loaded yet, display a spinner.
        if (content.html && content.meta) {
            setLoading(false);
        }
    }, [content]);
    var classes = ['content'];
    if (content.meta)
        classes = classes.concat(content.meta.classes);
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(OverlaySpinner, null),
        React.createElement(ManagementApiContent, null,
            React.createElement("section", { className: classes.join(' '), "data-swiftype-name": "body", "data-swiftype-type": "text", "data-swiftype-index": "true", dangerouslySetInnerHTML: { __html: content.html } }))));
};
